export default function (http) {
    return {
        queryByPage (data){
            return http.json({
                url: `/sys/question/result/query?pageNum=${data.pageNum}&pageSize=${data.pageSize}`,
                data
            });
        },
        getInfo (data){
            return http.json({
                url: `/sys/question/result/get?id=${data.id}`,
                data
            })
        },
        getOne(data){
            return http.json({
                url: `/sys/question/result/getOne`,
                data
            })
        },
        saveInfo (data){
            return http.json({
                url: `/sys/question/result/save`,
                data
            })
        },
        delete (data){
            return http.json({
                url: `/sys/question/result/delete`,
                data
            })
        },




    }
}



// WEBPACK FOOTER //
// ./src/configure/http/api/evaluateResult.js